// VIP 卡片列左右捲動提示（移植自切版 js/vip-scroll.js）
// region 為 .vvip-frame 或 .vip2-cards-wrap；沿用既有 .vip2-arrow-prev/next 按鈕，沒有就建立
// labels：{ prev, next } 建立按鈕時的 aria-label；回傳釋放函式
export function initVipScroll(region, labels = {}) {
  const strip = region && region.querySelector('.vvip-container, .vip2-cards')
  if (!strip) return () => {}
  region.classList.add('vip-scroll-region')
  strip.classList.add('vip-scroll-strip')
  strip.tabIndex = 0

  const created = []
  const button = direction => {
    let control = region.querySelector(`.vip2-arrow-${direction}`)
    if (!control) {
      control = document.createElement('button')
      if (labels[direction]) control.setAttribute('aria-label', labels[direction])
      region.append(control)
      created.push(control)
    }
    control.type = 'button'
    control.classList.add('vip-scroll-arrow', `vip-scroll-${direction}`)
    return control
  }
  const prev = button('prev')
  const next = button('next')

  const update = () => {
    const before = strip.scrollLeft > 1
    const after = strip.scrollLeft < strip.scrollWidth - strip.clientWidth - 1
    region.classList.toggle('can-scroll-prev', before)
    region.classList.toggle('can-scroll-next', after)
    prev.disabled = !before
    next.disabled = !after
  }
  const move = direction => {
    const card = strip.querySelector('.vip2-tier, .vvip-card, .vip2-card')
    if (!card) return
    const distance = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(strip).columnGap) || 0)
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    strip.scrollBy({ left: direction * distance, behavior: reduced ? 'auto' : 'smooth' })
  }
  const onPrev = () => move(-1)
  const onNext = () => move(1)
  const onKeydown = event => {
    if (event.target !== strip || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return
    event.preventDefault()
    move(event.key === 'ArrowLeft' ? -1 : 1)
  }
  prev.addEventListener('click', onPrev)
  next.addEventListener('click', onNext)
  strip.addEventListener('keydown', onKeydown)
  strip.addEventListener('scroll', update, { passive: true })
  const resizeObserver = window.ResizeObserver ? new ResizeObserver(update) : null
  if (resizeObserver) resizeObserver.observe(strip)
  update()

  return () => {
    prev.removeEventListener('click', onPrev)
    next.removeEventListener('click', onNext)
    strip.removeEventListener('keydown', onKeydown)
    strip.removeEventListener('scroll', update)
    if (resizeObserver) resizeObserver.disconnect()
    created.forEach(control => control.remove())
    ;[prev, next].forEach(control => control.classList.remove('vip-scroll-arrow', 'vip-scroll-prev', 'vip-scroll-next'))
    region.classList.remove('vip-scroll-region', 'can-scroll-prev', 'can-scroll-next')
    strip.classList.remove('vip-scroll-strip')
    strip.removeAttribute('tabindex')
  }
}
